export const isDevelopment = import.meta.env.MODE === 'development';
// Toggles OnePortal related UI changes. Enabled for local dev and integ, disabled for lab/staging/prod.
export const FEATURE_ONEPORTAL = import.meta.env.VITE_FEATURE_ONEPORTAL === 'true';
// Toggles OnePortal V2 features, e.g. the editable bikeleasing settings page. Disabled for prod/staging/lab, where only the static link out to the BLS portal is shown.
export const FEATURE_ONEPORTAL_V2 = import.meta.env.VITE_FEATURE_ONEPORTAL_V2 === 'true';

export const TENANT_MAX_IMAGE_SIZE = 500 * 1024;
export const TENANT_MIN_IMAGE_SIZE = 1024;
export const TENANT_MAX_PDF_SIZE = 5 * 1024 * 1024;
export const TENANT_MIN_PDF_SIZE = 1024;
export const APP_VERSION = __APP_VERSION__;
export const MAX_NON_CASH_MONTHLY_BUDGET_CENTS = 5000;
export const BIKELEASING_FAQ_URL = `${import.meta.env.VITE_BIKELEASING_URL}/faq`;
export const MARKETING_CONSENT_GIVEN_QUERY = 'marketingConsentGiven';
export const BIKELEASING_PRESELECTED_ROLE = 'ROLE_EMPLOYER';
